import { DateTime } from 'luxon';
import { empresa, empresas } from './empresas';

let cliente =  null;
let relacoes = [];
let vinculo_id = localStorage.getItem('vinculo_id');
let relacao_id = +localStorage.getItem('relacao_id');
let condominio_id = +localStorage.getItem('condominio_id');
let contrato_id = +localStorage.getItem('contrato_id');
let imovel_id = +localStorage.getItem('imovel_id');
let refresh_token = localStorage.getItem('refresh_token');
let agora = DateTime.local().toFormat('yyyy-LL-dd HH:mm:ss');



export default {
    loading: true,
    refresh_token,
    jwt: null,
    expiresAt: null,
    drawer: false,
    cliente,
    relacoes,
    relacao_id,
    condominio_id,
    contrato_id,
    imovel_id,
    vinculo_id,
    agora,
    empresas,
    empresa,
    configuracoes: []
};